import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import { useTranslation } from 'app/lang';
import Footer from 'app/modules/Layout/Footer';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import HistoryDeferred from './HistoryDeferred';

import dictionary from './History.dictionary.json';

const HistoryModule: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t(dictionary.title)}</title>
      </Helmet>

      <ErrorBoundary>
        <HistoryDeferred />
        <Footer />
      </ErrorBoundary>
    </>
  );
};

export default HistoryModule;
